import React from 'react';
import { CustomIcon, CustomIconSet } from '@social-solutions/ssg-forms';
import { tenantHelpers } from '../tenantInfo';

function renderLogo(tenant) {
    const { currentTenant } = tenant || {};
    const tenantLogoUrl = currentTenant && currentTenant.logoUrl;
    const bypassCache = `?param=${Math.random()}`;
    const logoUrl = !!tenantLogoUrl ? tenantLogoUrl + bypassCache : null;
    const productName = tenantHelpers.getProductName();
    return logoUrl ? <div id="org-logo" ><img className="logo" alt={`${productName} logo`} src={logoUrl} /></div>
      : <CustomIcon id="org-logo" iconChoice={CustomIconSet.ic_bonterra_logo_purple} />; 
  }

  export {
    renderLogo
  };


// WEBPACK FOOTER //
// src/acct/acct.util.js